import { ResidencePermit } from '@axo/shared/data-access/types';
import { useApplicationConditionalFilter } from '../../../../ConditionalWrappers/useApplicationConditionalFilter';
import { UnfilteredConditionalArray } from '../../../../ConditionalWrappers/types';
import { ApplicationConditionalContext } from '../../../../ConditionalWrappers/useApplicationConditionalContext';

const unfilteredResidencePermitOptions: UnfilteredConditionalArray<
  ApplicationConditionalContext,
  { value: ResidencePermit | null; label?: string }
> = [
  { value: { value: null, label: '-' } },
  { value: { value: ResidencePermit.No, label: 'No' } },
  { value: { value: ResidencePermit.Temporary, label: 'Temporary' } },
  { value: { value: ResidencePermit.Permanent, label: 'Permanent' } },
  {
    value: {
      value: ResidencePermit.ProofRegistration,
      label: 'Registration',
    },
  },
  {
    value: {
      value: ResidencePermit.ProofRightToUnlimited,
      label: 'Unlimited',
    },
  },
];

export const useResidencePermitOptions = () =>
  useApplicationConditionalFilter(unfilteredResidencePermitOptions);
